// Libraries
import { VictoryStyleInterface } from 'victory';
// Types
import { RatingKeys } from '@globalTypes/index';
// Utils
import { RatingList } from '@utils/constants';
import { colors } from '@theme/foundations';

/**
 * Generates an object containing area variations for each key in `RatingKeys`.
 *
 * @function
 * @returns {Object} An object with area variations.
 */
export const generateAreaVariations = () => {
  const areaVariations: Partial<Record<RatingKeys, VictoryStyleInterface>> = {};

  RatingList.forEach((key) => {
    areaVariations[key] = {
      data: {
        fill: colors.ratings[key].opacity,
      },
    };
  });

  return areaVariations;
};
